export default "__VITE_ASSET__Bcu88ktz__"